import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import classNames from 'classnames';
import _ from 'lodash';
import Moment from 'moment';
import Dropzone from 'react-dropzone';
import momentLocalizer from 'react-widgets/lib/localizers/moment';
import 'react-widgets/lib/less/react-widgets.less';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { Link, withRouter } from 'react-router';
import { Field, FieldArray } from 'redux-form';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Input, Tabs, Tab, Textarea, Image, Breadcrumb } from 'react-bootstrap';
import ContentWrapper from '../Layout/ContentWrapper';
import { DisabledSelection } from '../Common/selection';
import Selection from '../Common/selection';
import { InputField, DisabledInputField } from '../Common/inputField';
import HiddenInputField from '../Common/hiddenInputField';
import IsActive from '../Common/isActive';
import ConvertItemPrice from '../Common/convertItemPrice';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import Spinner from '../Widgets/spinner';
import ProductArrayDisabled from './productArrayDisabled';
import VendorForm from '../../containers/Products/vendorForm';
import { Translate, Localize } from 'react-redux-i18n';

momentLocalizer(Moment);



let renderPriceField = props => (
    <Input {...props.input} standalone type="text" addonBefore="$" addonAfter=".0000"/>
)


const renderInvoice = ({ fields }) => (
    <Row><Col sm={ 12 }>
        <Row><Col sm={ 12 }>
            <Button type="button" className="btn btn-green btn-green-default" onClick={() => {
                fields.push({})   // pushes empty child field onto the end of the array
            } }><i/> <Translate value="add_invoice" />
            </Button>
        </Col></Row>
        <Row><Col sm={ 12 }>
            {!fields.length && <div className="marginTopStyle" ><Translate value="no_invoice" /></div>}
            {fields.map((Invoice, index) =>
                <div key={ index }>
                    <Row className="marginTopStyle marginBottomStyle" >
                        <label className="col-sm-5"><Translate value="invoice_no" />{index + 1}</label>
                        <Button className="col-sm-3 btn btn-warning" type="button" onClick={() => {
                            fields.remove(index)  // remove from index
                        } }><i/> <Translate value="remove" />
                        </Button>
                    </Row>
                    <Row className="marginBottomStyle" >
                        <label className="col-sm-3 marginTopStyle" ><Translate value="vendor_invoice_no" />:</label>
                        <Col sm={ 8 }>
                            <Field name={`${Invoice}.VendorInvoiceNum`} component={ DisabledInputField }/>
                        </Col>
                    </Row>
                    <Row className="marginBottomStyle" >
                        <label className="col-sm-3 marginTopStyle" ><Translate value="invoice_total" />:</label>
                        <Col sm={ 8 }>
                            <Field name={`${Invoice}.InvoiceTotal`} component={ renderPriceField }/>
                        </Col>
                    </Row>
                    <Row className="marginBottomStyle" >
                        <label className="col-sm-3 marginTopStyle" ><Translate value="invoice_date" />:</label>
                        <Col sm={ 8 }>
                            <Field name={`${Invoice}.InvoiceDate`} component={ DisabledDatePicker }/>
                        </Col>
                    </Row>
                </div>
                ) }
        </Col></Row>
    </Col></Row>
)

class PurchaseScheduleForm extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            files: null,

            totalNetWeight: 0,
            totalShippingWeight: 0,
            totalPrice: 0,

            priceType: 'FOB',

            calculatedProducts: [],

            vendorInformationOpen: true,
            oneTimeScheduleOpen: true,
            purchaseInformationOpen: true,
            orderHistoryOpen: true,
            inventoryOpen: true,

            vendorAddress_id: null,
            vendorContact_id: null,
            carryType: null,
            deliverWarehouse_id: null,
            shippingCost: null,
            handlingCost: null,
            miscCost: null,
            miscCostDetail: null,
            discount: null,
            tax: null,
            finalPrice: null,
            noteToVendor: null,

            dirty: false,

            rows: [],
            selectedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        const { currentPurchaseSchedule, currentPurchaseTemplate } = this.props;
        if (currentPurchaseSchedule) {
            this.props.fetchPurchaseScheduleDetail(currentPurchaseSchedule.PurchaseSchedule_id)
                .then(() => {
                    this.props.fetchVendors();
                    this.props.fetchProducts();
                    this.props.fetchPaymentTerms();
                    this.props.fetchWarehouses();
                });
        }
        else if (currentPurchaseTemplate) {
            this.props.convertTemplateToSchedule(currentPurchaseTemplate.PurchaseTemplate_id)
                .then(() => {
                    this.props.fetchVendors();
                    this.props.fetchProducts();
                    this.props.fetchPaymentTerms();
                    this.props.fetchWarehouses();
                });
        }
        else {
            this.props.fetchVendors();
            this.props.fetchProducts();
            this.props.fetchPaymentTerms();
            this.props.fetchWarehouses();
        }

        // making a leaving hook to confirm leaving
        this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
    }

    componentDidUpdate() {
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.dirty != this.props.dirty) {
            this.setState({
                dirty: nextProps.dirty
            });
        }

        // Once user select a vendor, load its address and contacts.
        if (nextProps.vendorsValue != this.props.vendorsValue && nextProps.vendorsValue != null ) {
            this.props.fetchVendorDetail(nextProps.vendorsValue.value || nextProps.vendorsValue);
        }

        if (!nextProps.vendorsValue) {
            this.props.resetCurrentVendor();
        }


        if(nextProps.currentPurchaseScheduleDetail != this.props.currentPurchaseScheduleDetail
            && nextProps.currentPurchaseScheduleDetail ) {
            this.props.resetCurrentPurchaseTemplate();
            this.props.selectPurchaseTemplate(nextProps.currentPurchaseScheduleDetail.PurchaseTemplate);
            this.setState({vendorAddress_id: nextProps.currentPurchaseScheduleDetail.PurchaseTemplate.Pickup_VendorAddress_id});
            const purchaseTemplate = nextProps.currentPurchaseScheduleDetail.PurchaseTemplate;
            this.setState({vendorContact_id: purchaseTemplate.Pickup_VendorContact_id,
              carryType: purchaseTemplate.CarryType,
              deliverWarehouse_id: purchaseTemplate.Deliver_Warehouse_id,
              shippingCost: purchaseTemplate.ShippingCost,
              handlingCost: purchaseTemplate.HandlingCost,
              miscCost: purchaseTemplate.MiscCost,
              miscCostDetail: purchaseTemplate.MiscNote,
              discount: purchaseTemplate.Discount,
              tax: purchaseTemplate.TaxRate,
              finalPrice: purchaseTemplate.FinalPrice,
              noteToVendor: purchaseTemplate.NoteToVendor,
              totalNetWeight: purchaseTemplate.FinalNetWeight,
              totalShippingWeight: purchaseTemplate.FinalShippingWeight,
              totalPrice: purchaseTemplate.TotalPrice
            });
        }
        if(nextProps.priceTypeValue != this.props.priceTypeValue ) {
            this.setState({ priceType: nextProps.priceTypeValue });
        }

        // Calculate the sum of the price and weight for products.
        if (nextProps.products[0] && nextProps.productsValue) {

            let { products } = nextProps;

            let totalPrice = 0;
            let totalShippingWeight = 0;
            let totalNetWeight = 0;

            let calculatedProducts = nextProps.productsValue;

            function round(value, decimals) {
                return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
            }

            let newRows = [];
            calculatedProducts.map(
                line => {
                  let product = {};
                    if (line.Product_id) {
                        const index = _.findIndex(products, { 'Product_id': line.Product_id.value || line.Product_id });
                        if (index > -1) {
                            product["Product_id"] = products[index].Product_id;
                            product["Name"] = products[index].Name;
                            product["ProductNum"] = products[index].ProductNum;
                            product["Description"] = products[index].Description;
                            product["EstSalePrice"] = line.EstSalePrice; //products[index].LowestSalePrice;
                            product["Quantity"] = line.Quantity;
                            product["EstSaleTotal"] = line.EstSaleTotal;
                            product["FOBUnitPrice"] = line.FOBUnitPrice; //products[index].RefPrice;
                            product["ShippingWeight"] = line.TotalShippingWeight;
                            product["TotalPrice"] = line.TotalPrice;
                                  // product["MeasureUnit"] = line.Product_id.MeasureUnit;
                                  // product["RefNum"] = line.Product_id.RefNum;
                            newRows = [...newRows, product];
                        }
                    }
                    // totalPrice = (parseFloat(totalPrice) + (parseFloat(product.TotalPrice) || 0)).toFixed(2);
                    // totalShippingWeight = (parseFloat(totalShippingWeight) + (parseFloat(product.TotalShippingWeight) || 0)).toFixed(2);
                    // totalNetWeight = (parseFloat(totalNetWeight) + (parseFloat(product.TotalNetWeight) || 0)).toFixed(2);
                }
            )
            this.setState({ rows: newRows});
        }

    }

    // If the form is dirty, ask for confirmation.

    routerWillLeave(nextLocation) {
        if (this.state.dirty) return <Translate value="work_not_saved_warning" />
    }

    title() {
        if (!this.props.params.id) {
            return <div className="content-heading"><Translate value="create_a_new_purchase_schedule" /></div>
        }
        return <div className="content-heading"><Translate value ="edit_purchase_schedule" /> {this.props.currentPurchaseSchedule.PONum}</div>
    }

    // Render Select options dynamically with the information on the server.

    renderVendors() {
        if (this.props.vendorIsLoading) return <Spinner/> // If vendor is loading, show a spinner.
        else {
            let vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
            let vendorNumOptions = this.getVendorNumOptions();
            return (
              <Row className="marginBottomStyle" >
                    <Col sm={ 12 }>
                        <Row><Col sm={9}>
                            <label><Translate value="vendor_no" /></label>
                        </Col></Row>
                        <Row>
                            <Col sm={ 8 }>
                                <Field name="PurchaseTemplate.Vendor_id" component={DisabledSelection} options={vendorNumOptions}/>
                            </Col>
                        </Row>
                    </Col>
                    <br/>
                </Row>
            )
        }
    }


    renderVendorsDetail() {
        // if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/> // If vendor is loading, show a spinner.
        if (this.props.vendorError) return <div>Error</div> // If vendor is loading, show a spinner.
        else {
            let vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
            let vendorNumOptions = this.getVendorNumOptions();
            let vendorTelOptions = this.getVendorTelOptions();
            return (
              <Col xs={ 6 } id="vendor-info">
                <h4><Translate value="vendor_information" /></h4>
                <Row>
                  <label className="col-xs-4"><Translate value="name" /></label>
                  <div className="col-xs-6">
                    <Field name="PurchaseTemplate.Vendor_id" component={DisabledSelection} options={vendorNameOptions}/>
                  </div>
                </Row>
                <Row>
                  <label className="col-xs-4"><Translate value="vendor_no" /></label>
                  <div className="col-xs-6">
                    <Field name="PurchaseTemplate.Vendor_id" component={DisabledSelection} options={vendorNumOptions}/>
                  </div>
                </Row>
                <Row>
                  <label className="col-xs-4"><Translate value="phone" /></label>
                  <div className="col-xs-6">
                    <Field name="PurchaseTemplate.Vendor_id" component={DisabledSelection} options={vendorTelOptions}/>
                  </div>
                </Row>
            </Col>
            )
        }
    }

    // Push vendor name and number in to 2 JSON arrays.

    getVendorNameOptions() {
        var vendorNameOptions = [];
        this.props.vendors.map(vendor => {
            vendorNameOptions.push({ value: vendor.Vendor_id, label: vendor.Name })
        });
        return vendorNameOptions;
    }

    getVendorNumOptions() {
        let vendorNumOptions = [];
        this.props.vendors.map(vendor => {
            vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.VendorNum })
        });
        return vendorNumOptions;
    }

    getVendorTelOptions() {
      let vendorNTelOptions = [];
      this.props.vendors.map(vendor => {
          vendorNTelOptions.push({ value: vendor.Vendor_id, label: vendor.Telephone })
      });
      return vendorNTelOptions;
    }

    renderBillingAddress() {
        const { currentVendorDetail } = this.props;
        let contact, phone, address1, address2;
        if(currentVendorDetail) {
          if(currentVendorDetail.BillingContact) {
            contact = currentVendorDetail.BillingContact.FirstName + " " + currentVendorDetail.BillingContact.LastName
            phone = currentVendorDetail.BillingContact.Telephone
          }
          if(currentVendorDetail.BillingAddress) {
            address1 = currentVendorDetail.BillingAddress.Street;
            address2 = currentVendorDetail.BillingAddress.City + " " + currentVendorDetail.BillingAddress.State + currentVendorDetail.BillingAddress.Zip;
          }
        }
        return (
          <Col xs={ 6 } id="billing-info">
            <h4><Translate value="billing_information" /></h4>
            <Row>
              <label className="col-xs-4">
                <Translate value="contact" />:
              </label>
              <div className="col-xs-8">
                <Row>
                  {contact}
                </Row>
              </div>
            </Row>
            <Row>
              <label className="col-xs-4">
                <Translate value="phone" />:
              </label>
              <div className="col-xs-8">
                <Row>
                  {phone}
                </Row>
              </div>
            </Row>
            <Row>
              <label className="col-xs-4">
                <Translate value="address" />:
              </label>
              <div className="col-xs-8">
                <Row>
                  {address1}
                </Row>
                <Row>
                  {address2}
                </Row>
              </div>
            </Row>
          </Col>
        )
    }

    // Once a vendor is chosen, render its shipping address and contacts

    renderVendorAddress() {
        if ( this.props.vendorDetailIsLoading && !this.props.vendorDetailError ) return <Spinner/> // If vendor is loading, show a spinner.
        // else if ( this.props.vendorDetailError ) return <div>Error</div> // If vendor is loading, show a spinner.
        else if ( this.props.currentVendorDetail) {
            let vendorAddressOptions = this.getVendorAddressOptions();
            let vendorContactOptions = this.getVendorContactOptions();
            let vendorAddress = this.getDefaultVendorAddress(this.state.vendorAddress_id);
            let vendorContact = this.getDefaultVendorContact(this.state.vendorContact_id);
             return (
                 <Row>
                   <Col sm={ 6 }>
                        <label className="col-sm-5 inlineLabel" ><Translate value="pickup_vendor_address" /></label>
                          <Col sm={ 6 }>
                          <Field name="PurchaseTemplate.VendorAddress"
                            component={DisabledInputField}
                            placeholder={vendorAddress} />
                          </Col>
                  </Col>
                  <Col sm={ 6 }>
                    <label className="col-sm-5 inlineLabel"><Translate value="pickup_contact" /></label>
                    <Col sm={ 6 }>
                        <Field name="PurchaseTemplate.VendorContact"
                          component={DisabledInputField}
                          placeholder={vendorContact} />
                    </Col>
                    <br/>
                    {this.renderVendorContactInformation() }
                  </Col>
                 </Row>
            )
        }
        else return <h4 className='centerStyle' ><Translate value="msg_please_select_a_vendor" /></h4>
    }

    getVendorAddressOptions() {
        var vendorAddressOptions = [];
        this.props.currentVendorDetail.ShippingAddress.map(address => {
            vendorAddressOptions.push({ value: address.VendorAddress_id, label: address.Name+', '+address.City })
        });
        return vendorAddressOptions;
    }

    getDefaultVendorAddress(id) {
        var address = this.props.currentVendorDetail.ShippingAddress;
        const index = _.findIndex(address, { 'VendorAddress_id': id });
        if(index > -1){
          var label = address[index].Name+', '+address[index].City;
          return label;
        }
        return null;
    }

    getVendorContactOptions() {
        var vendorContactOptions = [];
        this.props.currentVendorDetail.ShippingContact.map(contact => {
            vendorContactOptions.push({ value: contact.VendorContact_id, label: contact.FirstName+' '+contact.LastName })
        });
        return vendorContactOptions;
    }
    getDefaultVendorContact(id) {
        var contact = this.props.currentVendorDetail.ShippingContact;
        const index = _.findIndex(contact, { 'VendorContact_id': id });
        if(index > -1){
          var label = contact[index].FirstName+' '+contact[index].LastName;
          return label;
        }
        return null;
    }


    renderVendorContactInformation() {
        const { currentVendorDetail, vendorsValue, vendorContactValue } = this.props;
        if(vendorContactValue && currentVendorDetail ) {
            const index = _.findIndex(currentVendorDetail.ShippingContact, { 'VendorContact_id': vendorContactValue });
            if (index != -1) return (
                <div>
                    <Row>
                        <Col sm={ 3 }>
                            <label><Translate value="name" />:</label>
                        </Col>
                        <Col sm={ 9 }>
                            {currentVendorDetail.ShippingContact[index].FirstName+' '+currentVendorDetail.ShippingContact[index].LastName}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={ 3 }>
                            <label><Translate value="email" />:</label>
                        </Col>
                        <Col sm={ 9 }>
                            {currentVendorDetail.ShippingContact[index].Email}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={ 3 }>
                            <label><Translate value="phone" />:</label>
                        </Col>
                        <Col sm={ 9 }>
                            {currentVendorDetail.ShippingContact[index].Telephone}
                        </Col>
                    </Row>
                </div>
            )
        }
    }

    // Render the Array of products.

    renderProducts() {

      if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
          const getRows = () => {
              return Data.Selectors.getRows(this.state);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }
          const handleGridSort = (sortColumn, sortDirection) => {
              var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
              this.setState(state);
          }

          const handleFilterChange = filter => {
              let newFilters = Object.assign({}, this.state.filters);
              if (filter.filterTerm) {
                  newFilters[filter.column.key] = filter;
              } else {
                  delete newFilters[filter.column.key];
              }
              this.setState({ filters: newFilters });
          }
          const columns = [
            {
                key: 'ProductNum',
                name: <Translate value="prod_num" />,
                resizable: true,
                sortable: true,
                width: 80,
                filterable: true
            },
            {
                key: 'RefNum',
                name: <Translate value="ref_num" />,
                resizable: true,
                sortable: true,
                width: 70,
                filterable: true,
            },
            {
                key: 'Name',
                name: <Translate value="prod_name" />,
                resizable: true,
                sortable: true,
                width: 200,
                filterable: true
            },
            {
                key: 'Description',
                name: <Translate value="desc" />,
                resizable: true,
                sortable: true,
                width: 85,
                filterable: true,
            },
            {
                key: 'Quantity',
                name: <Translate value="qty" />,
                resizable: true,
                sortable: true,
                width: 45,
                filterable: true,
            },
            {
                key: 'FOBUnitPrice',
                name: <Translate value="unit_dollarsign" />, //fix applied
                resizable: true,
                sortable: true,
                width: 65,
                filterable: true
            },
            {
                key: 'NetWeight',
                name: <Translate value="net_wt" />,
                resizable: true,
                sortable: true,
                width: 65,
                filterable: true,
            },
            {
                key: 'TotalPrice',
                name: <Translate value="total_dollarsign" />,
                resizable: true,
                sortable: true,
                width: 75,
                filterable: true,
            },
            {
                key: 'TotalNetWeight',
                name: <Translate value="total_wt" />,
                resizable: true,
                sortable: true,
                width: 80,
                filterable: true,
            },
            {
                key: 'MeasureUnit',
                name: <Translate value="pkg_type" />,
                resizable: true,
                sortable: true,
                width: 80,
                filterable: true
            },
            {
                key: 'PackageSize',
                name: <Translate value="package_size" />,
                resizable: true,
                sortable: true,
                width: 70,
                filterable: true
            },
            {
                key: 'Remark',
                name: <Translate value="notation" />,
                resizable: true,
                width: 200,
            }
          ];
            let productNumOptions = this.getProductNumOptions();
            let productNameOptions = this.getProductNameOptions();
            return (
              <Row><Col xm = {12}>
                <div className="react-table-customizer" id="PurchaseScheduleForm-dataGrid1">
                  <ReactDataGrid
                      rowKey='Product_id'
                      onGridSort={handleGridSort}
                      columns={columns}
                      rowHeight={25}
                      minHeight={215}
                      rowGetter={rowGetter}
                      rowsCount={ getSize() } />
                </div>
              </Col></Row>
            )
        }
    }

    getProductNumOptions() {
        var productNumOptions = [];
        this.props.products.map(product => {
            productNumOptions.push({ value: product.Product_id, label: product.ProductNum })
        });
        return productNumOptions;
    }

    getProductNameOptions() {
        var productNameOptions = [];
        this.props.products.map(product => {
            productNameOptions.push({ value: product.Product_id, label: product.Name })
        });
        return productNameOptions;
    }

    renderCarryTypeShippingMethod() {
      let carryTypeOptions = [
          { value: "Dry", label: "Dry" },
          { value: "Refrigerated", label: "Refrigerated" }
      ];
        let shippingMethodOptions = [
            { value: "Truckxi", label: "Truckxi" },
            { value: "Own Logistic", label: "Own Logistic" }
        ];
        let carryType = this.state.carryType;
        return (
            <Row>
                <Col sm={ 6 }>
                  <label className="col-sm-5 inlineLabel"><Translate value="carry_type" /></label>
                    <Col sm={ 6 }>
                        <Field name="CarryType"
                          component={DisabledInputField}
                          placeholder={carryType}/>
                    </Col>
                </Col>
                <Col sm={ 6 }>
                  <label className="col-sm-5 inlineLabel"><Translate value="shipping_method" /></label>
                    <Col sm={ 6 }>
                        <Field name="ShippingMethod" component={DisabledSelection} options={shippingMethodOptions}/>
                    </Col>
                </Col>
            </Row>
        )
    }

    renderRepeatFrequency() {
        let repeatFreqOptions = [
            { value: "Daily", label: "Day" },
            { value: "Weekly", label: "Week" },
            { value: "Monthly", label: "Month" }
        ];
        return (
            <Row>
                <label className="col-xs-4"><Translate value="repeat_frequency" /></label>
                <Col xs={4}><Field name="RepeatFrequency" component={Selection} options={repeatFreqOptions}/></Col>
            </Row>
        )
    }

    getDefaultWarehouse(id) {
        var warehouse = this.props.warehouses;
        const index = _.findIndex(warehouse, { 'Warehouse_id': id });
        if(index > -1){
          var label = warehouse[index].Name;
          return label;
        }
        return null;
    }

    renderWarehouse() {
        if (this.props.warehouseIsLoading) return <Spinner/> // If group is loading, show a spinner.
        else {
            let warehouseOptions = this.getWarehouseOptions();
            let warehouse = this.getDefaultWarehouse(this.state.deliverWarehouse_id);
            return (
                <Row>
                    <Col sm={ 12 }>
                      <label className="col-sm-5 inlineLabel" ><Translate value="deliver_warehouse" /></label>
                        <Col sm={ 6 }>
                            <Field name="Deliver_Warehouse_id"
                              component={DisabledInputField}
                              placeholder={warehouse}/>
                          </Col>
                    </Col>
                </Row>
            )
        }
    }

    getWarehouseOptions() {
        var warehouseOptions = [];
        this.props.warehouses.map(warehouse => {
            warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name })
        });
        return warehouseOptions;
    }

    renderRepeatOn(repeatFreq) {
        if(repeatFreq) repeatFreq = repeatFreq.value || repeatFreq
        let dayOptions = [];
        for (let i = 1; i < 61; i++) {
            let dayOption = {}
            dayOption['value'] = i;
            dayOption['label'] = i;
            dayOptions.push(dayOption);
        }
        let monthOptions = [];
        for (let i = 1; i < 32; i++) {
            let monthOption = {}
            monthOption['value'] = i;
            monthOption['label'] = i;
            monthOptions.push(monthOption);
        }
        let weekOptions=[
            {value: 0, label: "Monday"},
            {value: 1, label: "Tuesday"},
            {value: 2, label: "Wednesday"},
            {value: 3, label: "Thursday"},
            {value: 4, label: "Friday"},
            {value: 5, label: "Saturday"},
            {value: 6, label: "Sunday"},
        ]

        let repeatOnOptions = [];

        if(repeatFreq == "Daily") repeatOnOptions = dayOptions;
        else if (repeatFreq == "Weekly") repeatOnOptions = weekOptions;
        else if (repeatFreq == "Monthly") repeatOnOptions = monthOptions;

        return (
            <Row>
                <label className="col-xs-4"><Translate value="repeat_on" /></label>
                <Col xs={4}><Field name="RepeatInterval" component={Selection} options={repeatOnOptions}/></Col>
            </Row>
        )
    }

    // Render the Paymentterms select.

    renderPaymentTerms() {
        if (this.props.paymentTermsIsLoading) return <Spinner/> // If group is loading, show a spinner.
        else {
            let paymentTermOptions = this.getPaymentTermOptions();
            return (
                <Row>
                    <Col sm={ 10 }>
                        <label><Translate value="payment_term" /></label>
                        <Field name="PaymentTerm_id" component={DisabledSelection} options={paymentTermOptions}/>
                    </Col>
                </Row>
            )
        }
    }

    getPaymentTermOptions() {
        var paymentTermOptions = [];
        this.props.paymentTerms.map(paymentTerm => {
            paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name })
        });
        return paymentTermOptions;
    }

    // Implement the Headers which enable the function of collapsible

    purchaseInformationHeader(){
        return (
            <div onClick={ ()=> this.setState({ purchaseInformationOpen: !this.state.purchaseInformationOpen })} >
                <label style={{ cursor: "pointer" }} ><Translate value="purchase_information" /></label>
            </div>
        )
    }

    orderHistoryHeader(){
        return (
            <div onClick={ ()=> this.setState({ orderHistoryOpen: !this.state.orderHistoryOpen })} >
                <label style={{ cursor: "pointer" }} ><Translate value="order_history" /></label>
            </div>
        )
    }

    inventoryHeader(){
        return (
            <div onClick={ ()=> this.setState({ inventoryOpen: !this.state.inventoryOpen })} >
                <label style={{ cursor: "pointer" }} ><Translate value="inventory" /></label>
            </div>
        )
    }

    onDrop(files) {
        this.setState({
            files: files
        });
    }

    onOpenClick() {
        this.refs.dropzone.open();
    }

    renderPreview() {
        return (
            <div>
                <h4><Translate value="preview" /></h4>
                <hr/>
                <Row><Col sm={ 12 }>
                    <Image src={this.state.files[0].preview} thumbnail/>
                </Col></Row>
            </div>
        )
    }


    // If the user was directed to the page with a parameter,
    // then this page is edit page. Otherwise this is a create
    // page.

    handleFormSubmit(formProps) {
        this.setState({ dirty: false });
        if (!this.props.currentPurchaseSchedule)
            this.props.createPurchaseSchedule(formProps);
        else {
          if(!this.checkPermission("change_purchase_schedule"))
            this.props.editPurchaseSchedule(formProps);
          else
            alert("You have no permission!");
        }
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        const activeSchedule = (<Translate value="active_schedule" />);
        const convertItemPrice = (<Translate value="convert_item_price" />);
        const { handleSubmit, submitting, pristine } = this.props;
        let activeBreadcrumb = (this.props.currentPurchaseScheduleDetail) ? "edit_purchase_schedule" : "new_purchase_schedule";
        if (this.props.detailIsLoading && !this.props.detailError) return <ContentWrapper><br/>...<Translate value="reading_data" /></ContentWrapper>
        else if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{this.props.error}</div></ContentWrapper>
        else {
            return (
                <ContentWrapper>
                    <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                      <Breadcrumb style={this.state.crumbStyle}>
                        <Breadcrumb.Item>
                          <Translate value="purchase_management" />
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active="true">
                          <Translate value={activeBreadcrumb} />
                        </Breadcrumb.Item>
                      </Breadcrumb>
                      <ButtonToolbar>
                          <Button onClick={()=>{this.context.router.push("/purchaseSchedule")}} bsStyle="danger"><em className="fa fa-close"/></Button>
                          {/* <Button bsStyle="success" disabled={ submitting || pristine }><em className="fa fa-save"/></Button> */}
                          { (this.props.isCreating || this.props.isEditing) && <Spinner/> }
                          { this.props.createError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.createError)}</div> }
                          { this.props.editError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.editError)}</div> }
                          <Button bsStyle="success" disabled={ submitting || pristine } type="submit"><em className="fa fa-check marginRightStyle" /><Translate value="set_schedule" /></Button>
                      </ButtonToolbar>
                      <Grid id="purchase-schedule-form">
                        <Row>
                          <Col sm={3}><Field name="Name" component={InputField} placeholder="Schedule Name" /></Col>
                        </Row>
                        <Row>
                          <h2><Translate value="scheduled_template" /> : {this.props.currentPurchaseScheduleDetail?
                              this.props.currentPurchaseScheduleDetail.PurchaseTemplate.Name :
                              <Translate value="purchase_template_unavailable" />
                          }</h2>
                          <Panel id="purchase-schedule">
                            <Col xs={ 6 }>
                              <Row>
                                <label className="col-xs-4"><Translate value="start_date" /></label>
                                <Col xs={ 4 }>
                                    <Field name="StartDate" component={ DatePicker } />
                                </Col>
                              </Row>
                                {this.renderRepeatFrequency() }
                                {this.renderRepeatOn(this.props.repeatFreqValue) }
                              <Row id="is">
                                <Field name="IsEnabled" labelName={activeSchedule} component={ IsActive } />
                              </Row>
                            </Col>
                            <Col xs={ 6 }>
                              <label className="col-xs-2"><Translate value="description" /></label>
                              <Col xs={ 8 }>
                                  <Field name="Description" component="Textarea" className="form-control" style={{ minHeight: '100px' }}/>
                              </Col>
                            </Col>
                          </Panel>
                        </Row>
                        <Row>
                          <h2><Translate value="vendor_information" /></h2>
                          <Panel id="vendor-and-billing-information">
                            { this.renderVendorsDetail() }
                            { this.renderBillingAddress() }
                          </Panel>
                        </Row>
                        <Row>
                          <h2><Translate value="product_information" /></h2>
                          <Panel id="purchase-template-table">
                            {this.renderProducts()}
                          </Panel>
                        </Row>
                      </Grid>



                        {/* <Row>
                            <Col sm={ 8 }>
                                <Panel>
                                            <Panel>
                                              <h4><Translate value="pickup" /></h4>
                                              <hr/>
                                                {this.renderVendorAddress()}
                                            </Panel>
                                            <Row>
                                              <Col sm={ 4 }><Panel>
                                                  <h4><Translate value="deliver_warehouse" /></h4>
                                                  <hr/>
                                                  {this.renderWarehouse() }
                                              </Panel></Col>
                                            <Col sm={ 8 }><Panel>
                                              <h4><Translate value="carry_type_shipping_method" /></h4>
                                                <hr/>
                                                  {this.renderCarryTypeShippingMethod() }
                                              </Panel></Col>
                                          </Row>
                                          <h4><Translate value="product_information" /></h4>
                                            {this.renderProducts() }
                                            <Panel>
                                                <h4><Translate value="attachment_upload" /></h4>
                                                <hr/>
                                                <Dropzone onDrop={this.onDrop.bind(this)} className="well dropzone" >
                                                    <Button className="pull-right btn btn-default btn-primary"  onClick={this.onOpenClick} ><Translate value="upload_files" /></Button>
                                                    <div className="dz-default dz-message"><Translate value="msg_drop_upload_files" /></div>
                                                </Dropzone>
                                                {this.state.files && this.renderPreview() }
                                            </Panel>
                                </Panel>
                            </Col>
                            <Col sm={ 4 }>
                                <Panel className="panelStyle" header={this.purchaseInformationHeader()} collapsible expanded={this.state.purchaseInformationOpen}>
                                    <fieldset>
                                      <Row className="marginBottomStyle" >
                                        <Col>
                                          <Col sm={ 3 }><label className="col-sm-12 inlineLabel" ><Translate value="po_num" /></label></Col>
                                          <Col sm={ 9 }>
                                                <Field name="PurchaseTemplate.PONum" component={ DisabledInputField }/>
                                            </Col>
                                        </Col>
                                        </Row>
                                        <Row className="marginBottomStyle" >
                                          <Col sm={ 6 }>
                                            <label className="col-sm-6 inlineLabel" ><Translate value="purchase_status" /></label>
                                            <Col sm={ 6 }>
                                                <Field name="PurchaseTemplate.PurchaseStatus" component={ DisabledInputField }/>
                                            </Col>
                                          </Col>
                                          <Col sm={ 6 }>
                                            <label className="col-sm-6 inlineLabel" ><Translate value="payment_status" /></label>
                                            <Col sm={ 6 }><Field name="PurchaseTemplate.PaymentStatus" component={ DisabledInputField }/></Col>
                                          </Col>
                                        </Row>
                                    </fieldset>
                                    <fieldset>
                                      <Row className="marginBottomStyle" >
                                            <Col sm={ 6 }>
                                              <label className="col-sm-6 inlineLabel" ><Translate value="purchased_by" /></label>
                                                <Col sm={ 6 }><Field name="PurchaseTemplate.Purchaser_User_id" component={ DisabledInputField }/></Col>
                                            </Col>
                                            <Col sm={ 6 }>
                                              <label className="col-sm-6 inlineLabel" ><Translate value="last_modified_by" /></label>
                                                <Col sm={ 6 }><Field name="PurchaseTemplate.Modifier_User_id" component={ DisabledInputField }/></Col>
                                            </Col>
                                        </Row>
                                        <Row className="marginBottomStyle" >
                                                <Col sm={ 3 }><label className="col-sm-12 inlineLabel" ><Translate value="note" /></label></Col>
                                                <Col sm={ 9 }><label className="col-sm-12 centerStyle" >{this.state.noteToVendor} </label></Col>
                                        </Row>
                                    </fieldset>
                                    <fieldset>
                                      <Row className="marginBottomStyle" >
                                        <Col sm={ 6 }>
                                            <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="total_net_weight" /></label>
                                            <Field name="PurchaseTemplate.TotalNetWeight" component={ HiddenInputField } V={ this.state.totalNetWeight }/>
                                            <label className="col-sm-6 marginTopStyle inlineLabel" style={{paddingLeft: '8px'}}>{this.state.totalNetWeight} lb</label>
                                        </Col>
                                        <Col sm={ 6 }>
                                            <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="total_shipping_weight" /></label>
                                            <Field name="PurchaseTemplate.TotalShippingWeight" component={ HiddenInputField } V={ this.state.totalShippingWeight }/>
                                            <label className="col-sm-6 marginTopStyle inlineLabel" style={{paddingLeft: '8px'}}>{this.state.totalShippingWeight} lb</label>
                                        </Col>
                                        </Row>
                                    </fieldset>
                                    <fieldset>
                                      <Row className="marginBottomStyle" >
                                            <Col sm={ 6 }>
                                              <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="shipping_cost" /></label>
                                              <Col sm={ 6 }><Field name="PurchaseTemplate.ShippingCost" component={ DisabledInputField } placeholder={ this.state.shippingCost}/></Col>
                                            </Col>
                                            <Col sm={ 6 }>
                                              <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="handling_cost" /></label>
                                              <Col sm={ 6 }><Field name="PurchaseTemplate.HandlingCost" component={ DisabledInputField } placeholder={ this.state.handlingCost}/></Col>
                                            </Col>
                                        </Row>
                                        <Row className="marginBottomStyle" >
                                            <Col sm={ 6 }>
                                              <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="misc_cost" /></label>
                                              <Col sm={ 6 }><Field name="PurchaseTemplate.MiscCost" component={ DisabledInputField } placeholder={ this.state.miscCost}/></Col>
                                            </Col>
                                          </Row>
                                          <Row className="marginBottomStyle" >
                                            <Col sm={ 3 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="misc_cost_detail" /></label></Col>
                                              <Col sm={ 9 } style={{float: "left"}}>
                                                <Field name="PurchaseTemplate.MiscCostDetail" component={ DisabledInputField } placeholder={ this.state.miscCostDetail}/>
                                            </Col>
                                        </Row>
                                    </fieldset>
                                    <fieldset>
                                      <Row className="marginBottomStyle" >
                                        <label className="col-sm-3 marginTopStyle" ><Translate value="total_price" /></label>
                                            <Field name="PurchaseTemplate.TotalPrice" component={ HiddenInputField } V={ this.state.totalPrice } />
                                            <label className="col-sm-9" >$ {this.state.totalPrice}</label>
                                        </Row>
                                        <Row className="marginBottomStyle" >
                                            <Col sm={ 6 }>
                                                <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="discount" /></label>
                                                <Col sm={ 6 }><Field name="PurchaseTemplate.Discount" component={ DisabledInputField } placeholder={ this.state.discount}/></Col>
                                            </Col>
                                            <Col sm={ 6 }>
                                                <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="tax" /></label>
                                                <Col sm={ 6 }><Field name="PurchaseTemplate.Tax" component={ DisabledInputField } placeholder={ this.state.tax}/></Col>
                                            </Col>
                                        </Row>
                                        <Row className="marginBottomStyle" >
                                          <label className="col-sm-3 marginTopStyle" ><Translate value="final_dollarsign" /></label>
                                            <Col sm={ 7 }>
                                                <Field name="PurchaseTemplate.FinalPrice" component={ DisabledInputField } placeholder={ this.state.finalPrice}/>
                                            </Col>
                                        </Row>
                                    </fieldset>
                                    <fieldset>
                                        <Field name="PurchaseTemplate.ConvertItemPrice" labelName={convertItemPrice} component={ ConvertItemPrice }/>
                                    </fieldset>
                                </Panel>
                                <Panel header={this.orderHistoryHeader()} collapsible expanded={this.state.orderHistoryOpen}>
                                    <fieldset>
                                      <Row className="marginBottomStyle" >
                                            <Col>
                                              <Col sm={ 3 }><label className="col-sm-12 inlineLabel" ><Translate value="po_num" /></label></Col>
                                              <Col sm={ 9 }>
                                                <Field name="PONum" component={ DisabledInputField }/>
                                              </Col>
                                            </Col>
                                        </Row>
                                        <Row className="marginBottomStyle" >
                                            <Col sm={ 6 }>
                                                <label className="col-sm-6 inlineLabel" ><Translate value="quantity" /></label>
                                                <Col sm={ 6 }><Field name="Quantity" component={ DisabledInputField }/></Col>
                                            </Col>
                                            <Col sm={ 6 }>
                                                <label className="col-sm-6 inlineLabel" ><Translate value="unit_price" /></label>
                                                <Col sm={ 6 }><Field name="UnitPrice" component={ DisabledInputField }/></Col>
                                            </Col>
                                        </Row>
                                        <Row>
                                          <Col sm={ 6 }>
                                            <label className="col-sm-6 inlineLabel" ><Translate value="purchase_date" /></label>
                                            <Col sm={ 6 }>
                                                <Field name="PurchaseDate" component={ DisabledDatePicker }/>
                                            </Col>
                                          </Col>
                                        </Row>
                                    </fieldset>
                                </Panel>
                                <Panel header={this.inventoryHeader()} collapsible expanded={this.state.inventoryOpen}>
                                    <fieldset>
                                      <Row className="marginBottomStyle" >
                                        <Col sm={ 6 }>
                                            <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="in_stock" /></label>
                                            <Col sm={ 6 }>
                                                <Field name="PurchaseTemplate.InStock" component={ DisabledInputField }/>
                                            </Col>
                                        </Col>
                                        <Col sm={ 6 }>
                                              <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="ordered" /></label>
                                              <Col sm={ 6 }>
                                                <Field name="PurchaseTemplate.Ordered" component={ DisabledInputField }/>
                                              </Col>
                                        </Col>
                                        </Row>
                                        <Row className="marginBottomStyle" >
                                          <Col sm={ 6 }>
                                              <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="presale" /></label>
                                              <Col sm={ 6 }><Field name="PurchaseTemplate.PreSale" component={ DisabledInputField }/></Col>
                                            </Col>
                                            <Col sm={ 6 }>
                                              <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="saleable" /></label>
                                              <Col sm={ 6 }><Field name="PurchaseTemplate.Saleable" component={ DisabledInputField }/></Col>
                                            </Col>
                                        </Row>
                                    </fieldset>
                                    <fieldset>
                                      <Row className="marginBottomStyle" >
                                            <Col sm={ 6 }>
                                                <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="min_limit" /></label>
                                                <Col sm={ 6 }><Field name="PurchaseTemplate.MinLimit" component={ DisabledInputField }/></Col>
                                            </Col>
                                            <Col sm={ 6 }>
                                                <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="max_limit" /></label>
                                                <Col sm={ 6 }><Field name="PurchaseTemplate.MaxLimit" component={ DisabledInputField }/></Col>
                                            </Col>
                                        </Row>
                                        <Row className="marginBottomStyle" >
                                          <Col>
                                            <Col sm={ 3 }><label className="col-sm-12 inlineLabel" ><Translate value="default_location" /></label></Col>
                                            <Col sm={ 9 }>
                                                <Field name="PurchaseTemplate.DefaultLocation" component={ DisabledInputField }/>
                                            </Col>
                                          </Col>
                                        </Row>
                                    </fieldset>
                                </Panel>
                            </Col>
                        </Row> */}
                    </form>
                </ContentWrapper >
            )
        }
    }
}

export default withRouter(PurchaseScheduleForm);



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchaseScheduleForm.jsx